export const ADMIN = "admin";